import EventProduct from '../../../lib/model/EventProduct';

class EventProductEntryController {
  constructor(
    $q,
    EventProductService,
    TaskQueueService,
    LogService,
    StaffUserService
  ) {
    "ngInject";
    this.$q = $q;
    this.EventProductService = EventProductService;
    this.TaskQueueService = TaskQueueService;
    this.LogService = LogService;
    this.StaffUserService = StaffUserService;

    this._eventProducts = [];
    this._issueTypes = [];
    this._loaded = false;
    this._isSaving = false;
  }

  $onInit() {
    this._loadProducts();
  }

  get loaded() {
    return this._loaded;
  }

  get eventProducts() {
    return this._eventProducts;
  }

  get issueTypes() {
    return this._issueTypes;
  }

  get isSaving() {
    return this._isSaving;
  }

  _loadProducts() {
    const event = this.position && this.position.event;
    if (!event) {
      this.LogService.warn('EventProductEntry: No event found on position');
      this._loaded = true;
      return;
    }

    const eventsId = event.id;
    if (!eventsId) {
      this.LogService.warn('EventProductEntry: No event ID found');
      this._loaded = true;
      return;
    }

    // Try loading from API (gets existing data values for this staff user)
    const staffingUsersId = this.StaffUserService.currentUserId;
    this.EventProductService.getForEvent(eventsId, staffingUsersId)
      .then(result => {
        this._eventProducts = result.products;
        this._issueTypes = result.issueTypes || event.product_issue_types || [];
        this._loaded = true;
        this.LogService.info(`EventProductEntry: Loaded ${this._eventProducts.length} products from API`);
      })
      .catch(err => {
        // Offline fallback: use event model's product list (without existing data values)
        this.LogService.warn('EventProductEntry: Could not load from API, using sync data:', err);
        this._eventProducts = (event.event_products || []).map(p => new EventProduct(p));
        this._issueTypes = event.product_issue_types || [];
        this._loaded = true;
      });
  }

  onSave() {
    this._isSaving = true;
    const eventsId = this.position.event.id;

    const task = this.TaskQueueService.createTask('EventProductDataSaveTask');
    task.setData(eventsId, this._eventProducts);

    let savePromise;
    if (task.canExecute) {
      savePromise = task.execute()
        .then(() => {
          this.LogService.info('EventProductEntry: Product data saved successfully');
        })
        .catch(err => {
          this.LogService.error('EventProductEntry: Error saving product data:', err);
        });
    } else {
      savePromise = this.TaskQueueService.enqueue(task)
        .then(() => {
          this.LogService.info('EventProductEntry: Product data save task enqueued for later');
        });
    }

    savePromise.then(() => {
      this._isSaving = false;
      this.onExit();
    }).catch(err => {
      this._isSaving = false;
      this.LogService.error('EventProductEntry: Save failed:', err);
    });
  }

  onBack() {
    this.onExit();
  }
}

export default EventProductEntryController;
